import {Mapper} from '@s-ui/domain'

export class FromSubscriptionsRawDataToSpecificSubscriptionsMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Function} param.userEntityFactory
   */
  constructor({config, subscriptionsUserValueObjectFactory}) {
    super()

    this._config = config
    this._subscriptionsUserValueObjectFactory = subscriptionsUserValueObjectFactory

    this._externalServicesOffers = this._config.get('user').SUBSCRIPTIONS.EXTERNAL_SERVICES_OFFERS
    this._portalAnnouncements = this._config.get('user').SUBSCRIPTIONS.PORTAL_ANNOUNCEMENTS
    this._subscriptionsByType = {emails: [this._externalServicesOffers, this._portalAnnouncements]}
  }

  getSubscriptionsObject = subscriptions => {
    let tempObject = {}
    subscriptions.forEach(subscription => {
      const {name, isGranted} = subscription
      tempObject = {...tempObject, [name]: isGranted}
    })
    return tempObject
  }

  getSubscriptionsByType = (subscriptionsObj, type) => {
    let tempObject = {}
    this._subscriptionsByType[type].forEach(subscription => {
      tempObject = {...tempObject, [subscription]: subscriptionsObj[subscription]}
    })
    return tempObject
  }

  map = ({data}) => {
    const {email, subscriptions, type} = data
    const subscriptionsObj = this.getSubscriptionsObject(subscriptions)

    if (type === '' || subscriptions.length < 0)
      return this._subscriptionsUserValueObjectFactory({email, subscriptions: subscriptionsObj})

    const userSubscriptionsByType = this.getSubscriptionsByType(subscriptionsObj, type)
    return this._subscriptionsUserValueObjectFactory({email, subscriptions: userSubscriptionsByType})
  }
}
